// TODO: gate on a backend Resource once the documents domain is defined.
export const documentsLoader = () => null;
